import React from "react";
import "./Footer.css";
// import wp from "../../assets/whatsapp-logo.jpg"
import logo from "../../assets/logo.png"; // Assuming you have a logo.png file in your assets folder
const Footer = () => {
    return (
        <>
            <div className="Footer-container" id="about">


                <div className="box">

                    <link
                        rel="stylesheet"
                        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
                    />
                    <div className="hero1">
                        <h1>Reach us at</h1>
                        <hr />
                        <div className="home__social-icon">
                            <a href="Facebook"><i className="fab fa-facebook-f"> Facebook</i></a>
                            <a href="Instagram"><i className="fab fa-instagram"> Instagram</i></a>
                            <a href="Whatsapp link"><i className="fab fa-whatsapp">Whatsapp</i></a>
                            <a href="https://www.google.com/maps/">
                                <i className="fab fa-google">Google Maps</i></a>
                        </div>
                    </div>
                </div>
                <img src={logo} alt="" />
            </div>



        </>
    );
};

export default Footer;